var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.studentStatus==='trial')?_c('TrialLesson'):_vm._e(),(_vm.studentStatus==='full')?_c('Full'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }